var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2699D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.184 3C8.914 3 3 8.914 3 16.184C3 23.454 8.914 29.367 16.184 29.367C23.454 29.367 29.367 23.454 29.367 16.184C29.367 8.914 23.453 3 16.184 3ZM16.184 27.001C10.22 27.001 5.368 22.148 5.368 16.184C5.368 10.22 10.22 5.368 16.184 5.368C22.149 5.368 27.001 10.22 27.001 16.184C27.001 22.148 22.148 27.001 16.184 27.001Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 22.7319L17.0664 22.7319L17.0664 13.9989L15.0004 13.9989L15.0004 22.7319Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 12.0649L17.0664 12.0649L17.0664 9.99994L15.0004 9.99994L15.0004 12.0649Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.9868fe3e7e048e424314ef6589eeb4b3.svg";
export { ForwardRef as ReactComponent };